<template>
    <div>
        <el-card style="margin-top: -36px;margin-bottom: 50px;" class="box-card"></el-card>

        <el-card class="box-card" style="display: flex;flex-wrap: wrap;">
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">角色:</div>
                <div>
                    <el-select style="width: 100%" filterable  v-model="addTeacherForm.poId" autocomplete="off" placeholder="请选择角色" clearable>
                        <el-option v-for="jobStatu in roleTableData" :key="jobStatu.poId" :label="jobStatu.poName" :value="jobStatu.poId"></el-option>
                    </el-select>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">部门:</div>
                <div>
                    <el-select v-model="addTeacherForm.deptname" popper-class="tree-select-popper">
                        <el-option hidden :value="addTeacherForm.deptname"> </el-option>
                        <el-tree
                            :data="dataTree"
                            :props="defaultPropss"
                            node-key="deptId"
                            ref="belongingTree"
                            :highlight-current="true"
                            :check-on-click-node="true"
                            @check="handleTreeCheck">
                        </el-tree>
                    </el-select>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">姓名:</div>
                <div>
                    <el-input style="width: 100%;" placeholder="请输入姓名" v-model="addTeacherForm.realname" type="text" show-word-limit maxlength="10" ></el-input>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">性别:</div>
                <div>
                    <el-select style="width: 100%" filterable   v-model="addTeacherForm.sex" autocomplete="off" placeholder="请选择性别" clearable>
                        <el-option v-for="jobStatu in jobss" :key="jobStatu.jobId" :label="jobStatu.jobName" :value="jobStatu.jobId"></el-option>
                    </el-select>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;"> 一周能接受排课数量:</div>
                <div>
                    <el-input-number style="width: 100%;" placeholder="请输入一周能接受排课数量 " v-model="addTeacherForm.weekNum" controls-position="right"  :min="1" :max="1000"></el-input-number>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">年龄:</div>
                <div>
                    <el-input style="width: 100%;" placeholder="请输入年龄" v-model="addTeacherForm.age" type="text" show-word-limit maxlength="2" ></el-input>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">职级:</div>
                <div>
                    <!-- <el-select style="width: 100%" filterable   v-model="addTeacherForm.jobName" autocomplete="off" placeholder="请选择职级" clearable>
                        <el-option v-for="jobStatu in jobs" :key="jobStatu.jobId" :label="jobStatu.jobName" :value="jobStatu.jobId"></el-option>
                    </el-select> -->

                    <el-cascader clearable style="width: 100%;" v-model="rankId" :options="cascaderoptionsList1" :props="cascaderprops"></el-cascader>

                </div>
            </div>


            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">管理职级:</div>
                <div>
                    <el-select style="width: 100%" filterable  v-model="rankManageId" autocomplete="off" placeholder="请选择管理职级" clearable>
                        <el-option v-for="jobStatu in cascaderoptionsList" :key="jobStatu.id" :label="jobStatu.manageName" :value="jobStatu.id"></el-option>
                    </el-select>
                </div>
            </div>

            <!-- <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">薪资方案:</div>
                <div>

                    <el-select v-model="addTeacherForm.salaryPlanId" multiple filterable allow-create  default-first-option placeholder="请选择薪资方案">
                        <el-option v-for="(item,index) in planlist" :key="item.id" :label="item.planName" :value="item.id">
                            <template #default>
                                <div style="display: flex;justify-content: space-between;" v-if="item.planName">
                                    <div style="margin-right: 40px;width: 40%;">{{ item.planName }} </div>
                                    <div style="margin-right: 40px;width: 35%;" v-if="item.salaryPlanStartTime || item.salaryPlanEndTime"> {{ item.salaryPlanStartTime }} - {{ item.salaryPlanEndTime }} </div>
                                    <div style="margin-right: 35px;width: 20%;" @click.stop="handleFieldItemClick(item,'选择有效期',index)">选择有效期</div>
                                    <div style="margin-right: 20px;width: 10%;" @click.stop="handleFieldItemClick(item,'编辑')">编辑</div>
                                    <div style="width: 10%;" @click.stop="handleFieldItemClick(item,'详情')">详情</div>
                                </div>
                                <div style="display: flex;justify-content: flex-end;" v-if="item.if == '新增'">
                                    <div style="padding-left: 20px;color: #21aeef;" @click.stop="handleFieldItemClick(item,'新增')">新增</div>
                                </div>
                            </template>
                        </el-option>
                    </el-select>

                </div>
            </div> -->
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">在职状态:</div>
                <div>
                    <el-select style="width: 100%" filterable   v-model="addTeacherForm.jobStatus" autocomplete="off" placeholder="请选择在职状态" clearable>
                        <el-option v-for="item in names" :key="item.value" :label="item.label" :value="item.value"></el-option>
                    </el-select>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">学科:</div>
                <div>
                    <!-- <el-input style="width: 100%;" placeholder="请输入学科" v-model="addTeacherForm.teach" type="text" show-word-limit maxlength="20" ></el-input> -->
                    <el-select  placeholder="请选择学科"  v-model="addTeacherForm.teach" multiple  style="width: 100%"  clearable  filterable>
                        <el-option  v-for="item in subjectArr_s"  :key="item.id"   :value="item.id"   :label="item.categoryName"> </el-option>
                    </el-select>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">电话:</div>
                <div>
                    <el-input style="width: 100%;" placeholder="请输入电话" v-model="addTeacherForm.telephone" type="text" show-word-limit maxlength="11" ></el-input>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">邮箱:</div>
                <div>
                    <el-input style="width: 100%;" placeholder="请输入邮箱" v-model="addTeacherForm.email" type="text" show-word-limit maxlength="30" ></el-input>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">学历:</div>
                <div>
                    <el-input style="width: 100%;" placeholder="请输入学历" v-model="addTeacherForm.education" type="text" show-word-limit maxlength="30" ></el-input>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">毕业院校:</div>
                <div>
                    <el-input style="width: 100%;" placeholder="请输入毕业院校" v-model="addTeacherForm.graduationSchool" type="text" show-word-limit maxlength="30" ></el-input>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">身份证号:</div>
                <div>
                    <el-input style="width: 100%;" placeholder="请输入身份证号" v-model="addTeacherForm.cardId" type="text" show-word-limit maxlength="30" ></el-input>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">周一上课意愿:</div>
                <div>
                    <el-select style="width:100%;" filterable   v-model="addTeacherForm.monStatus" clearable>
                        <el-option v-for="item in workSchedule" :key="item.value" :label="item.value" :value="item.id"></el-option>
                    </el-select>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">周六课节数不超过:</div>
                <div>
                    <el-select v-model="addTeacherForm.satNum"  filterable  style="width:100%;" clearable>
                        <el-option v-for="item in workWeekend" :key="item.value" :label="item.value" :value="item.id"></el-option>
                    </el-select>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">周日课节数不超过:</div>
                <div>
                    <el-select v-model="addTeacherForm.sunNum"  filterable  style="width:100%;" clearable>
                        <el-option v-for="item in workWeekend" :key="item.value" :label="item.value" :value="item.id"></el-option>
                    </el-select>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">家庭地址:</div>
                <div>
                    <el-input style="width: 100%;" placeholder="请输入家庭地址" v-model="addTeacherForm.address" type="text" show-word-limit maxlength="30" ></el-input>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">报道日期:</div>
                <div>
                    <el-date-picker style="width: 100%" v-model="addTeacherForm.entryTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">转正日期:</div>
                <div>
                    <el-date-picker style="width: 100%" v-model="addTeacherForm.estimatedDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">培训日期:</div>
                <div>
                    <el-date-picker style="width: 100%" v-model="addTeacherForm.formalTrainingDate" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">招聘渠道:</div>
                <div style="margin-top: 8px;">
                    <el-radio v-model="addTeacherForm.radio" label="1">BOSS直聘</el-radio>
                    <el-radio v-model="addTeacherForm.radio" label="2">内推</el-radio>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;"  v-if="addTeacherForm.radio == '1'">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">Boss直聘来源负责人:</div>
                <div>
                    <el-input style="width: 100%;" placeholder="请输入家庭地址" v-model="addTeacherForm.bossName" type="text" show-word-limit maxlength="30" ></el-input>
                </div>
            </div>
            <div style=" display: flex;padding: 10px;width: 45%;"  v-if="addTeacherForm.radio == '2'">
                <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">内推人:</div>
                <div>
                    <el-input style="width: 100%;" placeholder="请输入家庭地址" v-model="name1" type="text" show-word-limit maxlength="30" ></el-input>
                </div>
            </div>

            <div style="margin-top: 6px;margin-right: 15px;width: 150px;text-align: end;">地域:</div>
            <div>
              <el-select v-model="addTeacherForm.regionName" clearable filterable placeholder="请选择所在地域" >
                <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
                :value="item.dictType"></el-option>
              </el-select>
            </div>
        </el-card>

        <GuciSalarPlan v-if="shoiwGuci" @handleEvent="handleEvent" :type="type" :currentRow="currentRow"></GuciSalarPlan>


        <el-dialog title="选择有效期" append-to-body :visible.sync="dialogVisible" width="60%" :close-on-click-modal="false" :before-close="dialogVisibleCle">
            <div style="display: flex;margin-bottom: 20px;">
                <div style="margin-right: 10px;">方案名称：</div>
                <div>{{ rowitme.planName }}</div>
            </div>
            <div style="display: flex;">
                <div style="padding-top: 10px; margin-right: 10px;">有效期：</div>
                <div>
                    <el-date-picker style="width: 100%;"
                        v-model="dateTimeList"
                        type="daterange"
                        value-format="yyyy-MM-dd"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"  clearable>
                     </el-date-picker>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisibleCle">取消</el-button>
                <el-button type="primary" @click="dialogVisibleCleSave">保存</el-button>
            </span>
        </el-dialog>


    </div>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
import { getSubject,} from "@/api/firstClassApi";
import GuciSalarPlan from './Guci-SalarPlan'

export default {
    components:{ GuciSalarPlan },
    data() {
        return {
            showDetails:false,
            shoiwGuci:false,
            dialogVisible:false,
            dateTimeList:[],
            addTeacherForm:{
                weekNum:0,
                salaryPlanId: [],
                bossName: "",
                graduationSchool: "",
                education: "",
                cardId: "",
                realname: "",
                jobtitle: "",
                teach: [],
                formalTrainingDate:'',
                telephone: "",
                introducerName: "",
                recruitmentChannel: "",
                email:"",
                radio: "1",
                age: "",
                jobStatus: "",
                jobName: "",
                entryTime: "",
                estimatedDate: "",
                monStatus: 1,
                satNum: 1,
                sunNum: 1,
                address: "",
                deptId:'',
                poId:'',
                deptname:'',
                regionName:'',
                
                sex:'',
            },

            rankManageId:'',
            rankId:'',

            name1:'',
            jobs: [],
            jobss: [{ jobId: 1, jobName: "男"},{ jobId: 2,jobName: "女"}],
            planlist: [],
            names: [{ value: 1, label: "在职"},{ value: 2,label: "离职"}],
            workSchedule: [ { value: "接受排课",id: 1,},{ value: "不接受排课", id: 2,}],
            workWeekend: [
                {value: "服从安排", id: 1,},
                { value: "不排课",id: 2,},
                {value: "排一节", id: 3,},
                {value: "排二节", id: 4,},
                { value: "排三节", id: 5,},
                { value: "排四节",id: 6,},
                { value: "排五节", id: 7,},
                {value: "排六节",id: 8,}
            ],

            roleTableData:[],
            dataTree:[],
            defaultPropss:{children: 'children', label: 'deptName' },
            subjectArr_s:[],
            rowitme: {},
            rowindex: 0,
            type:'',
            currentRow:null,


            optionsListt:[
                {dictValue:"北京", dictType:1 },
                {dictValue:"深圳", dictType:2 },
            ],




            cascaderprops: { checkStrictly: true, value: 'id', label: 'salaryPlanName', children: 'teacherRankList' },
            cascaderoptionsList: [],

            cascaderoptionsList1: [],
        }
    },

    mounted() {


      this.handdleApiAll()

    },

    methods: {

        dialogVisibleCleSave(){
            this.planlist[this.rowindex].salaryPlanStartTime = this.dateTimeList[0]
            this.planlist[this.rowindex].salaryPlanEndTime = this.dateTimeList[1]
            this.dialogVisible = false
            this.dateTimeList = []
        },

        dialogVisibleCle(){
            this.dateTimeList = []
            this.dialogVisible = false
        },

        handleEvent(e){
            this.shoiwGuci = false
        },

        dialogVisibleDetailsCle(){
            this.showDetails = false
        },

        handleFieldItemClick(itme,type,index){
            console.log(itme,type,index, 'handleFieldItemClick')

            if(type === '选择有效期'){
                this.rowindex = index
                this.rowitme = itme
                if(itme.salaryPlanStartTime){
                    // this.dateTimeList[0] = itme.salaryPlanStartTime
                    this.$set(this.dateTimeList,0,itme.salaryPlanStartTime)
                }
                if(itme.salaryPlanEndTime){
                    this.$set(this.dateTimeList,1,itme.salaryPlanEndTime)
                    // this.dateTimeList[1] = itme.salaryPlanEndTime
                }

                this.dialogVisible = true
            }
            if(type === '编辑'){
                this.type = '编辑'
                this.currentRow = itme
                this.shoiwGuci = true
            }
            if(type === '详情'){
                this.type = '详情'
                this.currentRow = itme
                this.shoiwGuci = true
            }
            if(type === '新增'){
                this.type = '新增'
                this.currentRow = null
                this.shoiwGuci = true
            }
        },

        handleTreeCheck(e){
            this.addTeacherForm.deptname = e.deptName
            this.addTeacherForm.deptId = e.deptId
        },
        handdleApiAll(){

            axios.get(`${apiBaseUrl}/teacher/query/job`,{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                    this.jobs = res.data.data.list;
             }).catch(error => {})


            axios.get(`${apiBaseUrl}/salaryPlan/salaryPlanNameList/${0}`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                    this.planlist = res.data.data
                    this.planlist.push({ if:'新增' })
            }).catch(error => { })


            axios.post(`${apiBaseUrl}/admin/postlist`,{ po_id: '0',  poName: '' },{headers:{ 'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => { 
                this.roleTableData = response.data.data.list
            })


            axios.get(`${apiBaseUrl}/organizational/getOrgTree`,{headers:{ 'authorization': sessionStorage.getItem('tokenInfo') }}).then((res)=>{ 
                this.dataTree = res.data.data
            })

            getSubject().then((res) => { 
                this.subjectArr_s = res.data;
            })

            
            axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,{ headers: { 'authorization': sessionStorage.getItem('tokenInfo') } }).then((res)=>{ 
                this.optionsListt = res.data.data
            })


            axios.get(`${apiBaseUrl}/teacherRankManage/findList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
                this.cascaderoptionsList = res.data.data
            }).catch(error => { })


            axios.post(`${apiBaseUrl}/teacherRank/findList`, {},{ headers:{ 'authorization': sessionStorage.getItem('tokenInfo')} }).then(res => {
                if(res.data.code == 200) {
                    this.cascaderoptionsList1 = res.data.data
                }else {
                    this.$message.error(res.data.message);
                    this.cascaderoptionsList1 =  []
                }
            }).catch(err => {
                this.cascaderoptionsList1 =  []
            });

        },

        handleSubmit(){

            if (this.addTeacherForm.radio == "1") {
                this.addTeacherForm.recruitmentChannel = "BOSS直聘";
                this.name1 = "";
            } else {
                this.addTeacherForm.recruitmentChannel = "内推";
                this.addTeacherForm.introducerName = this.name1;
                this.addTeacherForm.bossName = ""
            }
            this.addTeacherForm.jobtitle = this.addTeacherForm.jobName;

            // this.addTeacherForm.teach = JSON.stringify(this.addTeacherForm.teach)

            this.addTeacherForm.teach = this.addTeacherForm.teach.length > 0 ? '[' + this.addTeacherForm.teach + ']' : ''

            let salaryPlanList = []
            this.planlist.map((itme)=>{
                this.addTeacherForm.salaryPlanId.map((itmes)=>{
                    if(itmes == itme.id){
                        salaryPlanList.push({ salaryPlanId:itme.id, salaryPlanStartTime:itme.salaryPlanStartTime ? itme.salaryPlanStartTime : '', salaryPlanEndTime:itme.salaryPlanEndTime ? itme.salaryPlanEndTime : '' })
                    }
                })
            })
            // delete this.addTeacherForm.salaryPlanId
            this.addTeacherForm.salaryPlanList = salaryPlanList

            this.addTeacherForm.introducerName = this.name1;
            
            this.addTeacherForm.rankId = this.rankId.length > 0 ? this.rankId[this.rankId.length - 1] : ''
            this.addTeacherForm.rankManageId = this.rankManageId? this.rankManageId : ''

            this.$axios.post(`${apiBaseUrl}/teacher/add`, this.addTeacherForm,{  headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
                if (res.data.code == 200) {
                    this.$message({ message: "添加讲师成功", type: "success" });
                    this.addTeacherForm.teach = []
                    this.addTeacherForm.salaryPlanId = []
                    this.$emit('handleEventNodes',false)
                } else {
                    this.addTeacherForm.teach = []
                    this.addTeacherForm.salaryPlanId = []
                    this.$emit('handleEventNodes',true)
                    this.$message.error(res.data.message)
                }
            }).catch(error => {
                this.$message.error("添加讲师失败");
            })
        },



    },

}
</script>


<style lang="less" scoped>

    /deep/ .el-card__body{
        display: flex;
        flex-wrap: wrap;
    }
</style>




// WEBPACK FOOTER //
// src/teamOrganization/addMembers.vue